<template>
  <div class="eurostar-tickets-box">
    <div class="eurostar-tickets-box__illustration" aria-hidden="true">
      <svg
        class="eurostar-tickets-box__tickets"
        xmlns="http://www.w3.org/2000/svg"
        width="150"
        height="150"
        viewBox="0 0 150 150"
        fill="none"
      >
        <path d="M75.54 145.83C114.774 145.83 146.58 114.024 146.58 74.79C146.58 35.5557 114.774 3.75 75.54 3.75C36.3057 3.75 4.5 35.5557 4.5 74.79C4.5 114.024 36.3057 145.83 75.54 145.83Z" fill="#D3DEF2"/>
        <path d="M125.026 44.8737C129.518 44.1157 133.776 47.1424 134.534 51.6348L142.626 99.5526C143.384 104.045 140.357 108.302 135.865 109.061L117.056 112.237C115.897 109.077 112.619 107.089 109.179 107.67C105.74 108.251 103.296 111.205 103.239 114.571L29.955 126.946C25.4627 127.705 21.2057 124.677 20.4465 120.185L12.3545 72.2675C11.5958 67.7748 14.6229 63.5177 19.1156 62.759L92.3998 50.3833C93.5593 53.5432 96.8374 55.5301 100.276 54.9495C103.716 54.3687 106.159 51.4154 106.217 48.05L125.026 44.8737Z" fill="white"/>
        <path d="M132.316 52.0095C131.781 48.845 128.859 46.6794 125.706 47.0481L125.4 47.0923L108.235 49.991C107.42 53.588 104.516 56.5155 100.651 57.1681C96.7868 57.8204 93.0822 56.0092 91.1307 52.8795L19.4903 64.9776C16.2228 65.5293 14.0213 68.6254 14.5731 71.8929L22.6651 119.811L22.7238 120.114C23.4107 123.213 26.4159 125.262 29.5804 124.728L101.221 112.63C102.036 109.032 104.94 106.104 108.805 105.451C112.67 104.799 116.374 106.611 118.325 109.741L135.491 106.843L135.794 106.784C138.792 106.119 140.809 103.283 140.452 100.233L140.408 99.9272L132.316 52.0095ZM144.845 99.1779C145.81 104.895 141.957 110.314 136.24 111.28L115.588 114.767L114.944 113.012C114.151 110.849 111.905 109.491 109.554 109.888C107.203 110.286 105.528 112.306 105.489 114.608L105.457 116.478L30.3297 129.165C24.6117 130.131 19.1941 126.277 18.2279 120.56L10.1359 72.6422C9.17033 66.9242 13.0229 61.506 18.741 60.5404L93.8682 47.8535L94.512 49.6077C95.3053 51.7695 97.5512 53.1277 99.9018 52.7309C102.252 52.334 103.928 50.3137 103.967 48.011L103.999 46.1427L124.651 42.6552C130.368 41.6905 135.787 45.5422 136.753 51.2602L144.845 99.1779Z" fill="#3766C3"/>
        <path d="M125.026 44.8737C129.518 44.1157 133.776 47.1424 134.534 51.6348L136.581 63.7533L14.401 84.386L12.3545 72.2675C11.5958 67.7748 14.6229 63.5177 19.1156 62.759L92.3998 50.3833C93.5593 53.5432 96.8374 55.5301 100.276 54.9495C103.716 54.3687 106.159 51.4154 106.217 48.05L125.026 44.8737Z" fill="#FE6100"/>
        <path d="M132.316 52.0095C131.781 48.845 128.859 46.6794 125.706 47.0481L125.4 47.0923L108.235 49.991C107.42 53.588 104.516 56.5155 100.651 57.1681C96.7868 57.8204 93.0822 56.0092 91.1307 52.8795L19.4903 64.9776C16.2228 65.5293 14.0213 68.6254 14.5731 71.8929L16.2449 81.7928L133.988 61.9094L132.316 52.0095ZM139.174 65.5972L12.5571 86.9792L10.1359 72.6422C9.17033 66.9242 13.0229 61.506 18.741 60.5404L93.8682 47.8535L94.512 49.6077C95.3053 51.7695 97.5512 53.1277 99.9018 52.7309C102.252 52.334 103.928 50.3137 103.967 48.011L103.999 46.1427L124.651 42.6552C130.368 41.6905 135.787 45.5422 136.753 51.2602L139.174 65.5972Z" fill="#3766C3"/>
        <path d="M106.516 105.408C106.309 104.183 107.135 103.022 108.36 102.815C109.585 102.608 110.746 103.434 110.953 104.659L111.398 107.295L106.961 108.044L106.516 105.408ZM105.181 97.5003L104.29 92.2282C104.083 91.0029 104.909 89.8419 106.134 89.635C107.359 89.4281 108.521 90.2536 108.727 91.4789L109.618 96.751C109.825 97.9762 108.999 99.1373 107.774 99.3442C106.549 99.5511 105.387 98.7256 105.181 97.5003ZM102.955 84.3202L102.065 79.0481C101.858 77.8229 102.683 76.6618 103.908 76.4549C105.134 76.248 106.295 77.0735 106.502 78.2988L107.392 83.5709C107.599 84.7962 106.773 85.9572 105.548 86.1641C104.323 86.371 103.162 85.5455 102.955 84.3202ZM100.729 71.1401L99.8388 65.8681C99.6319 64.6428 100.457 63.4817 101.683 63.2748C102.908 63.0679 104.069 63.8935 104.276 65.1187L105.166 70.3908C105.373 71.6161 104.548 72.7771 103.322 72.984C102.097 73.1909 100.936 72.3654 100.729 71.1401ZM98.5033 57.96L98.0582 55.324L102.495 54.5747L102.94 57.2107C103.147 58.436 102.322 59.597 101.097 59.8039C99.8713 60.0109 98.7102 59.1853 98.5033 57.96Z" fill="#3766C3"/>
        <path d="M86.3661 90.3071L47.7041 96.836C46.4788 97.043 45.3177 96.2174 45.1108 94.9921C44.9039 93.7668 45.7295 92.6058 46.9548 92.3989L85.6168 85.8699C86.8419 85.6633 88.0032 86.4887 88.2101 87.7139C88.417 88.939 87.5912 90.1 86.3661 90.3071Z" fill="#3766C3"/>
        <path d="M38.9178 98.3198L31.888 99.5069C30.6627 99.7139 29.5016 98.8883 29.2947 97.663C29.0878 96.4377 29.9134 95.2767 31.1386 95.0698L38.1685 93.8826C39.3936 93.676 40.5549 94.5014 40.7618 95.7265C40.9686 96.9517 40.1428 98.1126 38.9178 98.3198Z" fill="#3766C3"/>
        <path d="M40.6984 108.864L33.6686 110.051C32.4433 110.258 31.2823 109.432 31.0753 108.207C30.8684 106.982 31.694 105.821 32.9193 105.614L39.9491 104.427C41.1742 104.22 42.3355 105.045 42.5424 106.271C42.7493 107.496 41.9235 108.657 40.6984 108.864Z" fill="#3766C3"/>
        <path d="M114.726 76.2925L128.784 73.9185L129.284 76.8766L115.225 79.2506L114.726 76.2925Z" fill="#3766C3"/>
        <path d="M115.663 81.8428L129.721 79.4688L130.72 85.385L116.662 87.7591L115.663 81.8428Z" fill="#3766C3"/>
        <path d="M117.1 90.3513L131.158 87.9772L131.658 90.9353L117.599 93.3094L117.1 90.3513Z" fill="#3766C3"/>
        <path d="M118.037 95.9016L132.095 93.5275L133.095 99.4438L119.036 101.818L118.037 95.9016Z" fill="#3766C3"/>
        <path d="M77.6027 102.632L49.4847 107.38C48.2594 107.587 47.0983 106.761 46.8914 105.536C46.6845 104.311 47.5101 103.15 48.7354 102.943L76.8534 98.1946C78.0785 97.988 79.2397 98.8134 79.4466 100.039C79.6535 101.264 78.8277 102.425 77.6027 102.632Z" fill="#3766C3"/>
        <path d="M131.335 37.6726C135.844 38.33 138.967 42.5173 138.31 47.0257L131.305 95.1144C130.647 99.6222 126.46 102.745 121.952 102.089L103.076 99.3392C102.943 95.9752 100.433 93.0774 96.9808 92.5745C93.529 92.0718 90.2965 94.1331 89.2094 97.3192L15.6638 86.6055C11.1554 85.9488 8.03312 81.7608 8.68926 77.2525L15.6945 29.1638C16.3513 24.6551 20.5389 21.5324 25.0476 22.1893L98.5931 32.9029C98.7269 36.2661 101.237 39.1632 104.688 39.6662C108.14 40.1689 111.372 38.1082 112.459 34.9229L131.335 37.6726Z" fill="white"/>
        <path d="M136.084 46.7014C136.546 43.5256 134.429 40.5676 131.316 39.9509L131.011 39.8991L113.785 37.3897C111.905 40.5627 108.242 42.4576 104.364 41.8927C100.486 41.3275 97.516 38.4667 96.6192 34.8891L24.7233 24.4158C21.4442 23.9381 18.3987 26.2091 17.921 29.4882L10.9158 77.5768L10.8785 77.8837C10.5812 81.0438 12.8124 83.9164 15.9882 84.379L87.8841 94.8524C89.7639 91.6786 93.4266 89.7832 97.3052 90.348C101.184 90.9131 104.153 93.7748 105.05 97.353L122.276 99.8624L122.583 99.8997C125.64 100.187 128.43 98.1071 129.026 95.0948L129.078 94.79L136.084 46.7014ZM133.531 95.4387C132.695 101.176 127.365 105.15 121.627 104.315L100.902 101.296L100.828 99.4277C100.736 97.1262 99.0156 95.1447 96.6565 94.801C94.2973 94.4575 92.0827 95.8658 91.3388 98.0454L90.7346 99.8152L15.3395 88.832C9.60113 87.9961 5.62772 82.6656 6.46276 76.9281L13.468 28.8395C14.304 23.1011 19.6335 19.1268 25.372 19.9628L100.767 30.9459L100.841 32.813C100.933 35.1139 102.654 37.0959 105.013 37.4397C107.371 37.7833 109.586 36.3747 110.33 34.1953L110.934 32.427L131.66 35.4461C137.397 36.2827 141.372 41.6117 140.537 47.3501L133.531 95.4387Z" fill="#3766C3"/>
        <path d="M131.335 37.6726C135.844 38.33 138.967 42.5173 138.31 47.0257L136.538 59.1874L13.9229 41.3255L15.6945 29.1638C16.3513 24.6551 20.5389 21.5324 25.0476 22.1893L98.5931 32.9029C98.7269 36.2661 101.237 39.1632 104.688 39.6662C108.14 40.1689 111.372 38.1082 112.459 34.9229L131.335 37.6726Z" fill="#FE6100"/>
        <path d="M136.084 46.7014C136.546 43.5256 134.429 40.5676 131.316 39.9509L131.011 39.8991L113.785 37.3897C111.905 40.5627 108.242 42.4576 104.364 41.8927C100.486 41.3275 97.516 38.4667 96.6192 34.8891L24.7233 24.4158C21.4442 23.9381 18.3987 26.2091 17.921 29.4882L16.4737 39.4234L134.636 56.6366L136.084 46.7014ZM138.441 61.7382L11.372 43.2277L13.468 28.8395C14.304 23.1011 19.6335 19.1268 25.372 19.9628L100.767 30.9459L100.841 32.813C100.933 35.1139 102.654 37.0959 105.013 37.4397C107.371 37.7833 109.586 36.3747 110.33 34.1953L110.934 32.427L131.66 35.4461C137.397 36.2827 141.372 41.6117 140.537 47.3501L138.441 61.7382Z" fill="#3766C3"/>
        <path d="M95.1401 89.6047C95.3192 88.3751 96.4613 87.5234 97.6909 87.7026C98.9206 87.8817 99.7722 89.0237 99.5931 90.2534L99.2077 92.8988L94.7547 92.2501L95.1401 89.6047ZM96.2962 81.6685L97.0669 76.3776C97.2461 75.148 98.3881 74.2963 99.6178 74.4755C100.847 74.6546 101.699 75.7967 101.52 77.0263L100.749 82.3172C100.57 83.5468 99.428 84.3984 98.1983 84.2193C96.9687 84.0402 96.1171 82.8981 96.2962 81.6685ZM98.223 68.4414L98.9938 63.1505C99.1729 61.9209 100.315 61.0693 101.545 61.2484C102.774 61.4275 103.626 62.5696 103.447 63.7992L102.676 69.0901C102.497 70.3197 101.355 71.1714 100.125 70.9922C98.8955 70.8131 98.0439 69.671 98.223 68.4414ZM100.15 55.2143L100.921 49.9235C101.1 48.6938 102.242 47.8422 103.471 48.0213C104.701 48.2004 105.553 49.3425 105.374 50.5721L104.603 55.863C104.424 57.0926 103.282 57.9443 102.052 57.7651C100.822 57.586 99.9707 56.4439 100.15 55.2143ZM102.077 41.9872L102.462 39.3418L106.915 39.9905L106.53 42.6359C106.351 43.8655 105.209 44.7172 103.979 44.538C102.749 44.3589 101.898 43.2169 102.077 41.9872Z" fill="#3766C3"/>
        <path d="M80.5975 69.048L41.7975 63.3959C40.5679 63.2168 39.7163 62.0747 39.8954 60.845C40.0745 59.6154 41.2166 58.7638 42.4462 58.9429L81.2462 64.595C82.4756 64.7744 83.3274 65.9164 83.1483 67.1459C82.9692 68.3754 81.827 69.2269 80.5975 69.048Z" fill="#3766C3"/>
        <path d="M32.98 62.1114L25.925 61.0837C24.6954 60.9046 23.8438 59.7625 24.0229 58.5328C24.202 57.3032 25.3441 56.4516 26.5737 56.6307L33.6287 57.6584C34.8581 57.8378 35.7099 58.9797 35.5308 60.2092C35.3517 61.4387 34.2095 62.2902 32.98 62.1114Z" fill="#3766C3"/>
        <path d="M31.4385 72.6931L24.3836 71.6653C23.1539 71.4862 22.3023 70.3442 22.4814 69.1145C22.6605 67.8848 23.8026 67.0332 25.0323 67.2123L32.0872 68.2401C33.3166 68.4194 34.1685 69.5614 33.9893 70.7909C33.8102 72.0204 32.668 72.8719 31.4385 72.6931Z" fill="#3766C3"/>
        <path d="M111.89 64.4138L125.998 66.4691L125.566 69.4377L111.457 67.3825L111.89 64.4138Z" fill="#3766C3"/>
        <path d="M111.078 69.9839L125.187 72.0392L124.322 77.9765L110.213 75.9213L111.078 69.9839Z" fill="#3766C3"/>
        <path d="M109.834 78.5227L123.943 80.5779L123.51 83.5466L109.402 81.4914L109.834 78.5227Z" fill="#3766C3"/>
        <path d="M109.023 84.0928L123.131 86.148L122.266 92.0854L108.158 90.0302L109.023 84.0928Z" fill="#3766C3"/>
        <path d="M68.4743 78.0882L40.2561 73.9776C39.0264 73.7984 38.1748 72.6564 38.3539 71.4267C38.533 70.1971 39.6751 69.3454 40.9048 69.5246L69.123 73.6352C70.3524 73.8146 71.2043 74.9566 71.0252 76.1861C70.8461 77.4156 69.7038 78.2671 68.4743 78.0882Z" fill="#3766C3"/>
      </svg>
    </div>

    <div class="eurostar-tickets-box__content">
      <h2 class="eurostar-tickets-box__title">
        {{ t('reservations.eurostarTitle') }}
      </h2>
      <p class="eurostar-tickets-box__body">
        {{ t('reservations.eurostarBody') }}
      </p>
      <p class="eurostar-tickets-box__reference">
        <span>{{ t('reservations.eurostarReference') }}</span>
        {{ ' ' }}
        <span class="eurostar-tickets-box__reference-value">{{ reference }}</span>
      </p>
      <a
        class="eurostar-tickets-box__cta"
        :href="manageBookingUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ t('reservations.eurostarCta') }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { getEurostarManageBookingUrl } from '@/utils/eurostarTickets'
  import { useStore } from '@/store'

  defineProps<{
    reference: string
  }>()

  const { t } = useI18n()
  const store = useStore()
  const manageBookingUrl = computed(() =>
    getEurostarManageBookingUrl(store.getters.getLocale)
  )
</script>

<style lang="scss" scoped>
.eurostar-tickets-box {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 28px;
  padding: 28px 32px;
  background: var(--white, #fff);
  border-radius: 16px;
  box-shadow: 0 8px 28px rgba(13, 20, 27, 0.08);
}

.eurostar-tickets-box__illustration {
  flex: 0 0 auto;
  width: 150px;
  display: flex;
  justify-content: center;
}

.eurostar-tickets-box__tickets {
  width: 150px;
  height: 150px;
}

.eurostar-tickets-box__content {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.eurostar-tickets-box__title {
  margin: 0 0 12px;
  font-family: var(--font-title);
  font-size: 24px;
  font-weight: 800;
  line-height: 32px;
  letter-spacing: -0.02em;
  color: var(--grey-grey-900, #0d141b);
}

.eurostar-tickets-box__body {
  margin: 0 0 16px;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--grey-grey-900, #0d141b);
}

.eurostar-tickets-box__reference {
  margin: 0 0 20px;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.4;
  color: var(--grey-grey-900, #0d141b);
}

.eurostar-tickets-box__reference-value {
  font-weight: 700;
}

.eurostar-tickets-box__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 12px 28px;
  border-radius: 999px;
  background: var(--primary-blue, #0042b8);
  color: var(--white, #fff);
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
  text-align: center;
}

.eurostar-tickets-box__cta:hover {
  opacity: 0.92;
  color: var(--white, #fff);
}

@media (max-width: 1199px) {
  .eurostar-tickets-box {
    flex-direction: column;
    align-items: flex-start;
    padding: 28px 20px 24px;
    gap: 16px;
    text-align: left;
  }

  .eurostar-tickets-box__illustration {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .eurostar-tickets-box__tickets {
    width: 120px;
    height: 120px;
  }

  .eurostar-tickets-box__content {
    width: 100%;
    align-items: flex-start;
  }

  .eurostar-tickets-box__title {
    margin-bottom: 10px;
  }

  .eurostar-tickets-box__body {
    margin-bottom: 14px;
    font-size: 0.875rem;
    line-height: 1.45;
  }

  .eurostar-tickets-box__reference {
    margin-bottom: 20px;
  }

  .eurostar-tickets-box__cta {
    width: auto;
    max-width: 100%;
    padding: 12px 24px;
  }
}
</style>
